import React from "react";

export const TENDERING_CREATE_STEPS = {
  DETAIL: 1,
  PAYMENT_TERMS: 2,
  SUMMARY: 3,
};

const QuotationTenderingContext = React.createContext({
  step: 1,
  setStep: () => {},
  goForward: () => {},
  goBack: () => {},
  details: {},
  setDetails: () => {},
  onSuccess: (id) => {},
});

export default QuotationTenderingContext;
